import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Login from "./login/Login";
import { getData, postData } from "../components/helpers/Data";
import { Spinner } from "../components/helpers/Spinner";
import MessageModal from "../components/helpers/Modal2";
import Modal5 from "../components/helpers/Modal5";
import { userSaveDetails } from "../components/helpers/UserSaveDetails";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";

const Items = () => {
  //create array for logs when renewing corp
  const logData = userSaveDetails(2);

  //module variables
  const [itemsData, setItemsData] = useState({ all: [], filtered: [] });
  const [searchQuery, setSearchQuery] = useState([]);
  const [appendeditem, setAppendeditem] = useState([]);
  const [messageModal, setIsMessageModal] = useState(false);
  const [responseModal, setResponseModal] = useState(false);
  const [response, setResponse] = useState(false);
  const [message, setMessage] = useState(false);
  const [itemImportData, setItemImportData] = useState([]);
  const [memberColumns, setMemberColumns] = useState([]);
  const [units, setUnits] = useState([]);
  var index = 0;

  useEffect(() => {
    getData("fetch_items")
      .then((data) => {
        setItemsData({ all: data, filtered: data });
      })
      .catch((error) => {
        console.log(error);
      });
    getData("fetch_units")
      .then((data) => {
        setUnits(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  //read excel
  const readExcel = (file) => {
    document.getElementById("spinner").style.display = "block";
    setItemImportData([]);
    setMemberColumns([]);
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (file) {
        fileReader.readAsArrayBuffer(file);

        fileReader.onload = (e) => {
          const bufferArray = e.target.result;

          const wb = XLSX.read(bufferArray, {
            type: "buffer",
            cellDates: true,
            cellNF: false,
            cellText: false,
          });

          const wsname = wb.SheetNames[0];

          //get column names and validate
          const workbookHeaders = XLSX.read(bufferArray, {
            sheetRows: 1,
          });
          const columns = XLSX.utils.sheet_to_json(
            workbookHeaders.Sheets[wsname],
            { header: 1 },
          )[0];
          if (
            columns[0] === "index" &&
            columns[1] === "item_name" &&
            columns[2] === "barcode" &&
            columns[3] === "quantity_per_item" &&
            columns[4] === "unit_of_measurement" &&
            columns[5] === "packaging" &&
            columns[6] === "category" &&
            columns[7] === "parent_category" &&
            columns[8] === "manufacturer" &&
            columns[9] === "feedback"
          ) {
            const ws = wb.Sheets[wsname];

            const data = XLSX.utils.sheet_to_json(ws, {
              raw: false,
              rawNumbers: true,
              dateNF: "YYYY-MM-DD",
            });
            setMemberColumns(columns);
            resolve(data);
          } else {
            resolve([]);
          }
        };

        fileReader.onerror = (error) => {
          reject(error);
        };
      } else {
        document.getElementById("spinner").style.display = "none";
      }
    });

    promise.then((dt) => {
      if (dt.length !== 0) {
        document.getElementById("spinner").style.display = "none";
        setItemImportData(dt);
      } else {
        document.getElementById("spinner").style.display = "none";
        setResponse("Warning! the excel columns are not correct");
        setResponseModal(true);
      }
    });
  };
  // append item
  const appendItemRow = (e) => {
    e.preventDefault();
    const row = {
      id: new Date().getTime().toString(),
      new: (
        <>
          <td></td>
          <td>
            <input
              type="text"
              name="item_added[]"
              className={"form-control"}
              style={{ width: "300px" }}
            />
          </td>
          <td>
            <input
              type="text"
              name="category_added[]"
              className={"form-control"}
              style={{ width: "300px" }}
            />
          </td>
          <td>
            <input
              type="text"
              name="parent_category_added[]"
              className={"form-control"}
              style={{ width: "300px" }}
            />
          </td>
          <td>
            <input
              type="number"
              name="quantity_per_item_added[]"
              className={"form-control"}
              style={{ width: "300px" }}
            />
          </td>
          <td>
            <select
              className={"form-control-sm units_added"}
              style={{ width: "200px" }}
            >
              <option disabled selected value="0">
                Choose Units
              </option>
              {units.map((dt) => {
                return <option value={dt.code}>{dt.units}</option>;
              })}
            </select>
          </td>
          <td>
            <input
              type="text"
              name="barcode_added[]"
              className={"form-control"}
              style={{ width: "300px" }}
            />
          </td>
          <td>
            <input
              type="text"
              name="packaging_added[]"
              className={"form-control"}
              style={{ width: "300px" }}
            />
          </td>
          <td>
            <input
              type="text"
              name="manufacturer_added[]"
              className={"form-control"}
              style={{ width: "300px" }}
            />
          </td>
          <td>
            <button
              className="btn text-danger btn-sm"
              onClick={(e) => removeitem(row.id, e)}
            >
              <i className="fas fa-trash fa-sm"></i>
            </button>
          </td>
        </>
      ),
    };

    setAppendeditem((appendeditem) => {
      return [...appendeditem, row];
    });
  };
  //remove bank row
  const removeitem = async (id, e) => {
    e.preventDefault();
    setAppendeditem((appendeditem) => {
      return appendeditem.filter((row) => row.id !== id);
    });
  };

  // Memoized filtered data
  // const filteredData = useMemo(() => {
  //   if (!searchQuery) {
  //     // If the search text is empty, return the initial data as is
  //     return itemsData.all;
  //   }

  // Filter the data based on the search text
  //   const filtered = itemsData.all.filter((item) => {
  //     // return console.log(item);
  //     (item.code !== null &&
  //       item.code
  //         .toString()
  //         .toLowerCase()
  //         .includes(searchQuery.toLowerCase())) ||
  //       (item.items !== null &&
  //         item.items
  //           .toString()
  //           .toLowerCase()
  //           .includes(searchQuery.toLowerCase())) ||
  //       (item.type_text !== null &&
  //         item.type_text.toLowerCase().includes(searchQuery.toLowerCase())) ||
  //       (item.state_text !== null &&
  //         item.state_text.toLowerCase().includes(searchQuery.toLowerCase())) ||
  //       (item.units_text !== null &&
  //         item.units_text.toLowerCase().includes(searchQuery.toLowerCase())) ||
  //       (item.quantity_per_item !== null &&
  //         item.quantity_per_item
  //           .toString()
  //           .toLowerCase()
  //           .includes(searchQuery.toLowerCase())) ||
  //       (item.wholesale_price_per_item !== null &&
  //         item.wholesale_price_per_item
  //           .toString()
  //           .toLowerCase()
  //           .includes(searchQuery.toLowerCase())) ||
  //       (item.retail_price_per_item !== null &&
  //         item.retail_price_per_item
  //           .toString()
  //           .toLowerCase()
  //           .includes(searchQuery.toLowerCase())) ||
  //       (item.quantity_stocked !== null &&
  //         item.quantity_stocked
  //           .toString()
  //           .toLowerCase()
  //           .includes(searchQuery.toLowerCase())) ||
  //       (item.quantity_available !== null &&
  //         item.quantity_available
  //           .toString()
  //           .toLowerCase()
  //           .includes(searchQuery.toLowerCase()));
  //   });

  //   return filtered;
  // }, [searchQuery, itemsData.all]);

  //search item
  const handleSearch = (e) => {
    const searchQuery = e.target.value;
    const filteredData = itemsData.all.filter(
      (item) =>
        (item.item_code !== null &&
          item.item_code.toString().toLowerCase() ===
            searchQuery.toLowerCase()) ||
        (item.name !== null &&
          item.name
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        (item.category !== null &&
          item.category
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        (item.parent_category !== null &&
          item.parent_category
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        (item.quantity_per_item !== null &&
          item.quantity_per_item
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        (item.unit_of_measurement !== null &&
          item.unit_of_measurement
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        (item.barcode !== null &&
          item.barcode
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        (item.packaging !== null &&
          item.packaging
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        (item.manufacturer !== null &&
          item.manufacturer
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())),
    );

    console.log(filteredData);

    setItemsData({ ...itemsData, filtered: filteredData });
  };

  //save item
  const saveItem = (e) => {
    e.preventDefault();

    // console.log(Object.fromEntries(frmData.entries()));
    // return;
    const errors_arr = [];
    //loop through table and check for null bank detail entries
    const tbl = document.querySelector("#item_tbl tbody").children;
    for (let trs of tbl) {
      const item_added = trs.children[1].children[0].value;
      if (!item_added) {
        errors_arr.push("Notice ! Enter item Details");
      }
    }
    if (errors_arr.length > 0) {
      setMessage("Notice ! Enter item Details");
      setIsMessageModal(true);
    } else {
      const frmData = new FormData(document.getElementById("item_form"));
      const units = document.querySelectorAll(".units");
      frmData.append("user", sessionStorage.getItem("mwerezi_mpos_username"));
      frmData.append("user_id", logData[0]);
      frmData.append("accessed_item", logData[1]);
      frmData.append("browser_type", logData[2]);
      frmData.append("os_type", logData[3]);

      units.forEach((element) => {
        frmData.append("unit_of_measurement[]", element.value);
      });

      postData(frmData, "save_item")
        .then((data) => {
          // return console.log(data);
          // setResponse(data[0]);
          // setResponseModal(true);
          // document.getElementById("spinner").display = "none";
          if (data.length == 1) {
            setResponse(data);
            setResponseModal(true);
          } else {
            setResponse(data.message);
            setResponseModal(true);

            //append feedback for imported stock
            const tbl = document.querySelector(
              "#item_import_tbl tbody",
            ).children;
            data.response.map((dt) => {
              for (let i = 0; i < tbl.length; i++) {
                const tr = tbl[i];
                const indexCol = tr.children[0].children[0].value;
                if (indexCol == dt.index) {
                  tr.children[9].children[0].value = dt.res;
                  let x = tr.children[9].children[0];
                  if (dt.res.includes("Error")) {
                    x.style.backgroundColor = "red";
                    x.style.color = "white";
                  } else {
                    x.style.backgroundColor = "green";
                    x.style.color = "white";
                  }
                }
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
          document.getElementById("spinner").display = "none";
        });
    }
  };
  //close message modal
  const closeMessageModal = () => {
    setResponseModal(false);
    // window.location.reload();
  };
  const logout = () => {
    if (typeof Storage !== "undefined") {
      localStorage.removeItem("mwerezi_mpos_username");
      localStorage.removeItem("mpos_fullname");
      localStorage.removeItem("mwerezi_mpos_usergroups");
      sessionStorage.removeItem("mpos_hasReloaded");
      ReactDOM.render(<Login />, document.getElementById("root"));
    } else {
      console.log("Sorry, something went wrong, please contact admin!");
    }
  };
  return (
    <div>
      <button className="btn btn-danger btn-sm" onClick={logout}>
        logout
      </button>
      <div>
        <div className="">
          <div className="row">
            <button
              className="btn btn-success btn-sm col-md-2"
              onClick={appendItemRow}
            >
              Add
            </button>
            <label
              className="col-form-label col-md-2 col-sm-2 label-align text-center pr-0 pl-0"
              for="member_no"
            >
              Import File:
            </label>
            <div className="col-md-4 col-sm-4 ">
              <input
                type="file"
                className="form-control"
                name="import_member_info"
                id="import_member_info"
                placeholder="Choose File"
                aria-required="true"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={(e) => {
                  const file = e.target.files[0];
                  readExcel(file);
                }}
              />
            </div>
            <input
              type="text"
              className="form-control col-md-12 m-2"
              placeholder="Type to search..."
              // onInput={(e) => setSearchQuery(e.target.value)}
              onInput={handleSearch}
            />
          </div>
          <form id="item_form" onSubmit={saveItem}>
            <div className="col-md-12 justify-content-center">
              <table
                className="table table-bordered table-bordered table-sm"
                style={{ maxHeight: "300px" }}
                id={"item_tbl"}
              >
                <thead className="table-fixed-header">
                  <tr>
                    <th>CODE</th>
                    <th>ITEMS</th>
                    <th>CATEGORY</th>
                    <th>PARENT CATEGORY</th>
                    <th>QUANTITY PER ITEM</th>
                    <th>UNIT OF MEASUREMENT</th>
                    <th>BARCODE</th>
                    <th>PACKAGING</th>
                    <th>MANUFACTURER</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {itemsData.filtered.map((dt) => {
                    return (
                      <tr key={dt.id}>
                        <td>
                          <input
                            type="text"
                            name="item_code[]"
                            className={"form-control text-center"}
                            defaultValue={dt.item_code}
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="name[]"
                            defaultValue={dt.name}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="category[]"
                            defaultValue={dt.category}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="parent_category[]"
                            defaultValue={dt.parent_category}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="quantity_per_item[]"
                            defaultValue={dt.quantity_per_item}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <select
                            className={"form-control-sm units"}
                            style={{ width: "200px" }}
                            value={dt.unit_of_measurement}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              // Assuming your state hook is named setItemsData
                              setItemsData((prev) => ({
                                ...prev,
                                filtered: prev.filtered.map((item) =>
                                  item.id === dt.id
                                    ? { ...item, unit_of_measurement: newValue }
                                    : item,
                                ),
                              }));
                            }}
                          >
                            <option disabled selected value="0">
                              Choose Units
                            </option>
                            {units.map((dt) => {
                              return (
                                <option value={dt.code}>{dt.units}</option>
                              );
                            })}
                          </select>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="barcode[]"
                            defaultValue={dt.barcode}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="packaging[]"
                            defaultValue={dt.packaging}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="manufacturer[]"
                            defaultValue={dt.manufacturer}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td></td>
                      </tr>
                    );
                  })}
                  {appendeditem.map((data) => {
                    return <tr key={data.id}>{data.new}</tr>;
                  })}
                </tbody>
              </table>
            </div>
            <span className="text text-success m-2 fw-bolder">
              Items Imported
            </span>
            <div className="col-md-12 justify-content-center">
              <table
                className="table table-bordered table-bordered table-sm"
                style={{ maxHeight: "300px" }}
                id={"item_import_tbl"}
              >
                <thead className="table-fixed-header">
                  <tr>
                    <th>INDEX</th>
                    <th>ITEMS</th>
                    <th>CATEGORY</th>
                    <th>PARENT CATEGORY</th>
                    <th>QUANTITY PER ITEM</th>
                    <th>UNIT OF MEASUREMENT</th>
                    <th>BARCODE</th>
                    <th>PACKAGING</th>
                    <th>MANUFACTURER</th>
                    <th>FEEDBACK</th>
                  </tr>
                </thead>
                <tbody>
                  {itemImportData.map((dt) => {
                    index++;
                    return (
                      <tr key={dt.id}>
                        <td>
                          <input
                            type="text"
                            name="index_import[]"
                            value={index}
                            className={"form-control"}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="item_import[]"
                            value={dt.item_name}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="category_import[]"
                            value={dt.category}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="parent_category_import[]"
                            value={dt.parent_category}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="quantity_per_item_import[]"
                            defaultValue={dt.quantity_per_item}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="unit_of_measurement_import[]"
                            defaultValue={dt.unit_of_measurement}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="barcode_import[]"
                            defaultValue={dt.barcode}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="packaging_import[]"
                            defaultValue={dt.packaging}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="manufacturer_import[]"
                            value={dt.manufacturer}
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="feedback[]"
                            className={"form-control"}
                            style={{ width: "250px" }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className={"row justify-content-center"}>
              <Spinner />
            </div>
            <div className={"row justify-content-center"}>
              <button className="btn btn-primary col-md-1" type="submit">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
      {/*Message modal*/}
      <Modal5
        modalIsOpen={messageModal}
        // background="#0047AB"
        body={
          <div>
            <div className={"row"}>
              <p className="text-blue font-weight-bold h4">{message}</p>
            </div>
          </div>
        }
        buttons={
          <div className={"row"}>
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={() => setIsMessageModal(false)}
            >
              OK
            </button>
          </div>
        }
      />
      {/*Response modal*/}
      <MessageModal
        modalIsOpen={responseModal}
        closeModal={closeMessageModal}
        background="#0047AB"
        body={<p className="text-white font-weight-bold h4">{response}</p>}
      />
    </div>
  );
};

export default Items;
